import { UserOrganization } from ".";
import { Statuses } from "../../domain";
import { ReactSelectOption } from "../generic";

export interface BasicOrganizationProfile {
    id: number;
    name: string;
    statusId: number;
}

export const OrganizationModelToForm = (org: UserOrganization): ReactSelectOption | BasicOrganizationProfile => {
    return {
        id: org.organizationId,
        name: org.organization || "",
        statusId: Statuses.Active.id,
        label: org.organization || "",
        value: org.organizationId,
    };
};



// WEBPACK FOOTER //
// ./src/models/organization/BasicOrganizationProfile.ts